window.Popup = require('../../commons/popup');
/**
 * Module for Statement of Conformity of the technical reference on product page
 */
module.exports = {

	/**
	 * initlization
	 */
	init: function(techRef) {
		new Popup({
			$container: $('.statementOfConformity', techRef.$el),
			bodySelector: '#statementOfConformity',
			linkSelector: '.statementOfConformity-link',
			bodyCls: 'soc-dialog',
			printBtnSelector: '.btn-print',
			printDivId: 'statementOfConformity'
		});
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/js/modules/product/tech-ref/soc.js
// module id = 251
// module chunks = 6